import { createFileRoute } from '@tanstack/react-router'
import { SettingsListPage, type SettingsTab } from '@/components/settings/settings-list-page'

/** Internal admin (not client-scoped): API enforces `is_admin`. */
export const Route = createFileRoute('/settings/')({
  validateSearch: (search: Record<string, unknown>): { tab?: SettingsTab } =>
    search.tab === 'placeholders' ? { tab: 'placeholders' } : {},
  component: SettingsIndex,
})

function SettingsIndex() {
  const { tab = 'organisations' } = Route.useSearch()
  const navigate = Route.useNavigate()
  return (
    <SettingsListPage
      tab={tab}
      onTabChange={(next) =>
        navigate({ search: next === 'placeholders' ? { tab: next } : {}, replace: true })
      }
    />
  )
}
